import { createOrUpdate, createOrUpdateJSON } from "@/utils/functions";
import { getAPI } from "@/api/axios-base";

export const createOrUpdateFormData = (url, body, imageField) => {
  const formdata = new FormData();

  for (const key in body) {
    if (!(imageField && key === imageField && body[key] && typeof body[key] !== "object")) {
      formdata.append(key, body[key]);
    }
  }

  if (body.uuid) {
    return getAPI.patch(`${url}${body.uuid}/`, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } else {
    return getAPI.post(url, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
};

export class ApiController {
  createOrUpdate2Steps;
  createOrUpdateFormData;
  createOrUpdateJson;
  delete;
  getter;
  getterById;
  toggle;

  constructor(url, imageField = "") {
    this.getter = (params) => getAPI.get(url, { params });

    this.getterById = (uuid) => getAPI.get(`${url}${uuid}/`);

    this.delete = (uuid) => getAPI.delete(`${url}${uuid}/`);

    this.createOrUpdateJson = (body) => createOrUpdateJSON(url, body);

    this.createOrUpdateFormData = (body) => createOrUpdateFormData(url, body, imageField);

    if (imageField) {
      this.createOrUpdate2Steps = (body) => createOrUpdate(url, body, imageField);
    } else {
      this.createOrUpdate2Steps = (body) => createOrUpdateJSON(url, body);
    }

    this.toggle = (body) =>
      getAPI.patch(url + `${body.uuid}/`, {
        is_active: body.is_active,
      });
  }
}
